import { Button } from "@mui/material";
import React from "react";
import { FormattedMessage } from "react-intl";
import { listBtnAccountInfoPage } from "../utils/constant";

const GroupTab = ({ tab, handleChangeTab, extraAchievement }) => {
  return (
    <div className="md:w-full flex flex-row my-2 overflow-x-auto scrollbar-hide sm:py-3 lg:py-0">
      {listBtnAccountInfoPage.map((item) => (
        <div
          key={item.tab}
          className="sm:py-2 text-center lg:pb-1"
          id="tab-account"
        >
          <Button
            sx={{ textTransform: "none" }}
            className={`flex items-center mr-3 gap-1 font-semibold justify-center h-[32px] rounded-[16px] ${
              tab === item.tab
                ? "bg-green-gradient text-white"
                : "bg-gray text-gray400"
            }`}
            onClick={() => handleChangeTab(item.tab)}
          >
            <span>{item.tab === tab ? item.iconActive : item.icon}</span>
            <span className="whitespace-nowrap text-[13px] font-[400]">
              <FormattedMessage id={item.title} />{" "}
              {item?.tab === "achievements" && extraAchievement}
            </span>
          </Button>
        </div>
      ))}
    </div>
  );
};
export default GroupTab;
